module.exports = __webpack_public_path__ + "img/shopping-basket.df790696.svg";